// 手机号预约地区、手机号、预约按钮
export const PHONE_SELECTOR = '.input-in, .pop-input-in'
export const AREA_SELECTOR = '.area, .pop-area'
export const BASIC_SUBMIT_SELECTOR = '.btn-reservation'
export const POPUP_SUBMIT_SELECTOR = '.pop-btn-reservation'
export const SUBMIT_SELECTOR = `${BASIC_SUBMIT_SELECTOR}, ${POPUP_SUBMIT_SELECTOR}`

// 所有 google play，ios 按钮
export const ALL_GP_SELECTOR = [
    '.btn-gp',
    '.btn-pre[data-type=gp]',
    '.btn-reward[data-type=gp]',
    '.btn-float-reservation[data-type=gp]',
    '.pop-btn-gp',
    '.btn-nav-gp',
    '.btn-store-gp',
    '.store-pop-btn-gp',
    '.btn-bottom-gp',
    '.btn-reserve[data-type=gp]',
    '.btn-store-gp',
    '.short-btn-link-gp',
    '.pop-store-btn-gp',
    '.btn-gift-reservation[data-type=gp]',
    '.btn-bottom-reservation[data-type=gp]',
    '.btn-link-gp',
    '.pop-btn-ios-gp[data-type=gp]',
    '.btn-ios-gp[data-type=gp]',
    '.btn-reserve[data-type=gp]',
    '.btn-bottom-store[data-type=gp]',
    '.gp',
].join(',')
export const ALL_IOS_SELECTOR = [
    '.btn-ios',
    '.btn-pre[data-type=ios]',
    '.btn-reward[data-type=ios]',
    '.btn-float-reservation[data-type=ios]',
    '.pop-btn-ios',
    '.btn-nav-ios',
    '.btn-store-ios',
    '.store-pop-btn-ios',
    '.btn-bottom-ios',
    '.btn-reserve[data-type=ios]',
    '.btn-store-ios',
    '.short-btn-link-ios',
    '.pop-store-btn-ios',
    '.btn-gift-reservation[data-type=ios]',
    '.btn-bottom-reservation[data-type=ios]',
    '.btn-link-ios',
    '.pop-btn-ios-gp[data-type=ios]',
    '.btn-ios-gp[data-type=ios]',
    '.btn-reserve[data-type=ios]',
    '.btn-bottom-store[data-type=ios]',
    '.ios',
].join(',')

// 所有 fb 按钮
export const FB_BTN_SELECTOR = [
    '.btn-facebook',
    '.btn-nav-fb',
    '.btn-fb',
    '.facebook',
    '.btn-nav-like',
].join(',')
// 所有 twitter 按钮
export const TWITTER_BTN_SELECTOR = ['.btn-twitter', '.twitter'].join(',')
// 所有 discord 按钮
export const DISCORD_BTN_SELECTOR = ['.btn-discord', '.discord'].join(',')

// kakao channel 按钮
export const KAKAO_BTN_SELECTOR = [
    '.btn-talk',
    '.item-link2',
    '.btn-nav-talk',
    '.btn-community-talk',
].join(',')

// naver cafe 按钮
export const CAFE_BTN_SELECTOR = [
    '.btn-cafe',
    '.item-link3',
    '.btn-nav-cafe',
    '.btn-community-cafe',
].join(',')

// 弹窗
export const BASIC_POPUP_SELECTOR = '.pop-message-success'
export const PRE_POPUP_SELECTOR = '.pop-pre'
export const INPUT_ERROR_POPUP_SELECTOR = '.pop-pre-shake'
export const PRE_SUCCESS_POPUP_SELECTOR = '.pop-pre-success'
export const HAD_PRE_POPUP_SELECTOR = '.pop-pre-had'
export const RULE_POPUP_SELECTOR = '.pop-rule'
export const AGREEMENT_POPUP_SELECTOR = '.pop-agreement'

// 商店版弹窗
export const SHOP_PRE_POPUP_SELECTOR = '.pop-through-pre'
export const SHOP_PRE_SUCCESS_POPUP_SELECTOR = '.pop-pre-success'

// 角色页容器（滚动到指定位置时，打开弹窗）
export const ROLE_POPUP_HOST_SELECTOR = '.container3'

// 预约规则按钮
export const PRE_RULE_SELECTOR = '.btn-rule'

// 奖励规则按钮
export const GIFT_RULE_SELECTOR = '.btn-rule-prize'

// 预约详情按钮
export const PRE_AGREEMENT_SELECTOR = '.agreement'
// 社区规则按钮
export const COMMUNITY_RULE_SELECTOR = '.btn-rule-community'

// pangle弹窗
export const PANGLE_POPUP = '.pop-pangle'
export const PANGLE_BUTTONS = ['.pop-pangle-btn'].join(',')
export const PANGLE_GP_BUTTONS = ['.pop-pangle-btn[data-type=gp]'].join(',')
export const PANGLE_IOS_BUTTONS = ['.pop-pangle-btn[data-type=ios]'].join(',')
export const IGNORE_TRIGGER_PANGLE_BUTTONS = [].join(',')
